import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators } from "redux";

import cx from "classnames";

import { openMiniCart } from "state/actions/ui/miniCartUIactions";

import { Image, Button } from "components/base";

import { ExternalRoutes } from "constants/Routes";

import { GlobalState, Checkout } from "types";

interface StoreProps {
  checkout: Checkout;
  errorPage: boolean;
}

interface DispatchProps {
  actions: {
    openMiniCart(): void;
  };
}

type Props = StoreProps & DispatchProps;

interface State {
  bgColorIsWhite: boolean;
}

const defaultProps = {
  errorPage: false
};

const minniemuseHomeButtonAriaLabel = "Navigate to minniemuse.com";
const minniemuseShopButtonAriaLabel = "Navigate to mmerch.com";
const cartButtonAriaLabel = "Open cart";

class Nav extends Component<Props, State> {
  static defaultProps = defaultProps;

  state: State = {
    bgColorIsWhite: false
  };

  scrollPosition: number = 0;

  componentDidMount() {
    window.addEventListener("scroll", this.handleNavBgColor);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleNavBgColor);
  }

  handleNavBgColor = (): void => {
    const currentScrollPosition = document.body.getBoundingClientRect().top;

    if (currentScrollPosition === 0) {
      this.setState({ bgColorIsWhite: false });
    } else if (currentScrollPosition > this.scrollPosition) {
      this.setState({ bgColorIsWhite: true });
    } else {
      this.setState({ bgColorIsWhite: false });
    }

    this.scrollPosition = currentScrollPosition;
  };

  render() {
    const { checkout, actions, errorPage } = this.props;

    return (
      <div
        className={cx("Nav fixed t0 r0 l0 z-nav flex items-center transition", {
          "bg-color-white": !errorPage && this.state.bgColorIsWhite
        })}
      >
        <div className="col-2 md:col-4">
          <Button
            className="Nav__home-logo"
            containerClassName="md:none"
            ariaLabel={minniemuseHomeButtonAriaLabel}
            to={ExternalRoutes.MINNIEMUSE_HOME_LINK}
          >
            <Image
              alt={minniemuseHomeButtonAriaLabel}
              src="/assets/images/minniemuse-home-icon.svg"
            />
          </Button>
          <Button
            className="Nav__home-button color-gray-darker gt-america text-bold text-xs uppercase p0 transition"
            containerClassName="none md:inline-block"
            ariaLabel={minniemuseHomeButtonAriaLabel}
            label="minniemuse.com"
            to={ExternalRoutes.MINNIEMUSE_HOME_LINK}
          />
        </div>
        <div className="col-8 md:col-4 flex justify-center">
          <Button
            containerClassName="w100 flex justify-center"
            className="Nav__shop-logo flex items-center w100"
            ariaLabel={minniemuseShopButtonAriaLabel}
            to="/"
          >
            <Image
              alt={minniemuseShopButtonAriaLabel}
              src="/assets/images/minniemuse-shop-logo.svg"
            />
          </Button>
        </div>
        {!errorPage && (
          <div className="col-2 md:col-4 flex justify-end">
            <Button
              className="Nav__cart-icon w100 p0 bg-color-transparent relative"
              ariaLabel={cartButtonAriaLabel}
              onClick={actions.openMiniCart}
            >
              <Image
                alt={cartButtonAriaLabel}
                src="/assets/images/cart-icon.svg"
              />
              {!!checkout.totalLineItemsCount && (
                <span className="Nav__cart-item-count absolute color-gray-darker uppercase text-xs gt-america">
                  {checkout.totalLineItemsCount}
                </span>
              )}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: GlobalState) => ({
  checkout: state.session.checkout.checkout
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      openMiniCart
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nav);
